module.exports = global["Phaser"] = require("-!/Users/jesper/WebstormProjects/king-rail/node_modules/phaser/build/custom/phaser-split.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/phaser/build/custom/phaser-split.js
 ** module id = 304
 ** module chunks = 1
 **/